import { getDealers } from 'api/dealers'
import { URL_PARSE_OPTIONS, URL_STRINGIFY_OPTIONS } from 'application/configuration'
import { createEffect, createEvent, createStore } from 'effector'
import { appendUrl } from 'lib/append-url'
import { parseUrl } from 'query-string'

import { DealerProps } from '../types'

const getDealersFromUrl = () => {
  const dealers = parseUrl(window.location.href, URL_PARSE_OPTIONS).query.dealer

  if (Array.isArray(dealers)) {
    return dealers
  } else if (typeof dealers === 'string') {
    return [dealers]
  } else {
    return []
  }
}

/**
 * Все дилеры
 */
export const $dealers = createStore<DealerProps[]>([])

/**
 * Активный (выбраный в данный момент) дилер
 */
export const $activeDealer = createStore<DealerProps | null>(null)

/**
 * активный таб в ДЛ в мобильной версии
 */
export const $activeTabMobileInDL = createStore<number>(0)

/**
 * Идёт ли загрузка дилеров в данный момент
 */
export const $fetching = createStore(true)

/**
 * Дилеры переданные через url. Если не передано ничего, то показывать всех дилеров.
 * Если какие-то дилеры переданы, то показывать только их
 */
export const $dealersFilter = createStore(getDealersFromUrl())

/**
 * Запрос на дилеров
 */
export const fetchDealersFx = createEffect(({ getCitiesUrl, cities }: { getCitiesUrl: string; cities: string[] }) => {
  const finalUrl = appendUrl({
    url: getCitiesUrl,
    data: { cities },
    stringifyOptions: URL_STRINGIFY_OPTIONS,
    parseOptions: URL_PARSE_OPTIONS
  })

  return getDealers(finalUrl)
})

/**
 * Указать активного дилера
 */
export const setActiveDealer = createEvent<DealerProps | null>()

/**
 * Установка активного таба
 */
export const setActiveTabMobileInDL = createEvent<number>()

/**
 * Получилась ли ошибка в результате загрузки
 */
export const $error = createStore<string | null>(null)

/**
 * TODO: убрать этот костыль когда запустим новый список
 */
export const getCitiesFromStorageFx = createEffect((): string[] => {
  const localStorageItem = localStorage.getItem('@kodix/avn')
  if (localStorageItem) {
    const cities = JSON.parse(localStorageItem).cities
    return cities
  } else return []
})

export const init = createEvent<string>()
